import { z } from "zod";

import { CHARGE_LIST_SORT_FIELDS } from "../../entities/charge/constants";
import { zodEnum } from "../../shared/lib/zod-enum";
import { SORT_DIRECTIONS } from "../../shared/types/sort";

export const chargeFilterSearchSchema = z.object({
  statuses: z.array(z.string()).optional(),
  rentAreas: z.array(z.string()).optional(),
  types: z.array(z.string()).optional(),
});

export const chargesSearchParamsSchema = z
  .object({
    sorting: z
      .enum(zodEnum(Object.values(CHARGE_LIST_SORT_FIELDS)))
      .optional()
      .catch(undefined),
    sortingDir: z
      .enum(zodEnum(Object.values(SORT_DIRECTIONS)))
      .optional()
      .catch(undefined),
  })
  .merge(chargeFilterSearchSchema);

export type ChargesSearch = z.infer<typeof chargesSearchParamsSchema>;
export type ChargesFilterSearch = z.infer<typeof chargeFilterSearchSchema>;
